import "@/index.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";

import { Navbar } from "@/site/Navbar";
import { Hero } from "@/site/Hero";
import { ProblemSection } from "@/site/ProblemSection";
import { Services } from "@/site/Services";
import { Process } from "@/site/Process";
import { Industries } from "@/site/Industries";
import { Portfolio } from "@/site/Portfolio";
import { Pricing } from "@/site/Pricing";
import { Testimonials } from "@/site/Testimonials";
import { FAQ } from "@/site/FAQ";
import { LeadForm } from "@/site/LeadForm";
import { Footer } from "@/site/Footer";
import { StickyMobileCTA } from "@/site/StickyMobileCTA";

const Home = () => {
  return (
    <main data-testid="page-home" className="min-h-screen bg-white">
      <Navbar />
      <Hero />
      <ProblemSection />
      <Services />
      <Process />
      <Industries />
      <Portfolio />
      <Pricing />
      <Testimonials />
      <FAQ />
      <LeadForm />
      <Footer />
      <StickyMobileCTA />
    </main>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
